/**
 * Placeholder for partners without custom vocabulary
 */
export default {}